
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navItems = [
    { path: '/', label: '首页' },
    { path: '/series', label: '系列' },
    { path: '/archive', label: '时间档案' },
    { path: '/collector', label: '藏家会' }
  ];

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#D4AF37]/10' : 'bg-transparent'
      }`}
    >
      <div className="px-6 md:px-16 py-4 md:py-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-3 md:space-x-4 group cursor-pointer">
          <img 
            src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/ce28744b70aae809fa456af269a7a54e.png"
            alt="懂藏"
            className="h-8 md:h-10 w-auto object-contain"
          />
          <div className="flex flex-col">
            <span className="font-['Optima',serif] text-[12px] md:text-[14px] text-[#E5E4E2] tracking-wider">
              重塑时间的权力
            </span>
            <span className="text-[9px] md:text-[10px] text-[#D4AF37] tracking-[0.3em]">
              TeaTea.com.cn
            </span>
          </div>
        </Link>

        {/* Desktop Nav Items */}
        <div className="hidden md:flex items-center space-x-12">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="relative group cursor-pointer whitespace-nowrap"
            >
              <span className={`text-[11px] tracking-wider transition-colors duration-300 ${
                location.pathname === item.path 
                  ? 'text-[#D4AF37]' 
                  : 'text-[#E5E4E2] group-hover:text-[#D4AF37]'
              }`}>
                {item.label}
              </span>
              <span className={`absolute -bottom-1 left-1/2 h-[1px] bg-[#D4AF37] transition-all duration-300 ${
                location.pathname === item.path
                  ? 'w-full -translate-x-1/2'
                  : 'w-0 group-hover:w-full group-hover:-translate-x-1/2'
              }`} />
            </Link>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          aria-label="菜单"
        >
          <div className="w-5 h-4 flex flex-col justify-between">
            <span className={`w-full h-[1px] bg-[#D4AF37] transition-all duration-300 ${
              isMobileMenuOpen ? 'rotate-45 translate-y-[7px]' : ''
            }`} />
            <span className={`w-full h-[1px] bg-[#D4AF37] transition-all duration-300 ${
              isMobileMenuOpen ? 'opacity-0' : ''
            }`} />
            <span className={`w-full h-[1px] bg-[#D4AF37] transition-all duration-300 ${
              isMobileMenuOpen ? '-rotate-45 -translate-y-[7px]' : ''
            }`} />
          </div>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden fixed inset-0 top-[72px] bg-[#0A0A0A]/98 backdrop-blur-md transition-all duration-500 ${
        isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      }`}>
        <div className="flex flex-col items-center justify-center h-full space-y-8 px-6">
          {navItems.map((item, index) => (
            <Link
              key={item.path}
              to={item.path}
              className="relative group cursor-pointer"
              style={{
                opacity: isMobileMenuOpen ? 1 : 0,
                transform: isMobileMenuOpen ? 'translateY(0)' : 'translateY(20px)',
                transition: `all 0.5s ease-out ${index * 0.1}s`
              }}
            >
              <span className={`text-[16px] tracking-wider transition-colors duration-300 ${
                location.pathname === item.path 
                  ? 'text-[#D4AF37]' 
                  : 'text-[#E5E4E2]'
              }`}>
                {item.label}
              </span>
              {location.pathname === item.path && (
                <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-12 h-[1px] bg-[#D4AF37]" />
              )}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
